

import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { LayoutTabla } from "../../layout";
import { AlertScreen } from "../components/AlertScreen";
import { useCentroCostoStore } from "../../../store";
import { separadorMillares } from "../../../helpers";
import { useEffect } from "react";





export const TablaTotalConsumoCentros = () => {


    const { totalesCentros, startLimpiarTotalesCentos } = useCentroCostoStore();
    

    useEffect(() => {
        return () => { startLimpiarTotalesCentos() }
    }, [])
    

    return (

        <>
        {(totalesCentros) &&
        <LayoutTabla>
            <TableHead>
                <TableRow>
                    <TableCell sx={{width:'30%'}}># Productos</TableCell>
                    <TableCell sx={{width:'30%'}}>Cantidades</TableCell>
                    <TableCell sx={{width:'40%'}}>Total</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow> 
                    <TableCell>{ totalesCentros.productos }</TableCell>
                    <TableCell>{ totalesCentros.totalCantidad }</TableCell>
                    <TableCell>{`$${separadorMillares(totalesCentros.totalCosto)}`}</TableCell>
                </TableRow>
            </TableBody>
        </LayoutTabla>
        }
        </>
    )
}
